import React from 'react';
import * as z from 'zod';

import type { ContentEditorContextValue } from '../ContentEditor/contexts';

const CopyPasteContentSchema = z.object({
    space: z.string(),
    organization: z.string(),
});

/**
 * Hook to get the copy/paste context for the editor.
 */
export function useEditorCopyPaste(input: {
    organization: string;
    space: string;
}): ContentEditorContextValue['copyPaste'] {
    return React.useMemo(() => {
        return {
            getContext: () => ({
                organization: input.organization,
                space: input.space,
            }),
            parseContext: (str) => {
                if (typeof str !== 'string') {
                    throw new Error(`parseContext expected string, got ${typeof str}`);
                }

                try {
                    const parsed = JSON.parse(str);
                    return CopyPasteContentSchema.parse(parsed);
                } catch (err) {
                    if (err instanceof z.ZodError) {
                        throw err;
                    }

                    throw new Error(`Failed to parse copy/paste context: ${err.message} ${str}`);
                }
            },
        };
    }, [input.space, input.organization]);
}
